export const REHYDRATE = "REHYDRATE";

export const setIsRehydrate = () => ({
	type: REHYDRATE,
});
